import { z } from 'zod';
import { 
  loginSchema, 
  createUserSchema, 
  userSchema,
  roleSchema,
  roleAssignmentSchema
} from './schemas';
import { handleValidationError } from '../handlers/validation';

export function validateLogin(data: unknown) {
  try {
    return loginSchema.parse(data);
  } catch (error) {
    if (error instanceof z.ZodError) {
      handleValidationError(error);
    }
    throw error;
  }
}

export function validateCreateUser(data: unknown) {
  try {
    return createUserSchema.parse(data);
  } catch (error) {
    if (error instanceof z.ZodError) {
      handleValidationError(error);
    }
    throw error;
  }
}

export function validateUser(data: unknown) {
  try {
    return userSchema.parse(data);
  } catch (error) {
    if (error instanceof z.ZodError) {
      handleValidationError(error);
    }
    throw error;
  }
}

export function validateRole(role: unknown): boolean {
  try {
    roleSchema.parse(role);
    return true;
  } catch {
    return false;
  }
}

export function validateRoleAssignment(roleAssignment: unknown): boolean {
  try {
    roleAssignmentSchema.parse(roleAssignment);
    return true;
  } catch {
    return false;
  }
}

export function validateRoles(roles: unknown[]): boolean {
  if (!Array.isArray(roles)) return false;
  return roles.every(role => validateRoleAssignment(role));
}